const excludedParams = ['aswparam'];
const regexp = new RegExp(`&amp;?(${excludedParams.join('|')})=[^&amp;\n]*`);

/**
 * Exclude banned params from object array
 * @param {object} params Params data
 * @returns {object} filtered object
 */
const fromArray = (params) => {
	const filteredObjectEntries = Object.entries(params)
		.filter(([key]) => !excludedParams.includes(key))
		.map(([key, value]) => [key, value.string]);

	return Object.fromEntries(filteredObjectEntries);
};

/**
 * Filter excluded params from URL
 * @param {string} url
 * @returns {string} filtered url
 */
const fromUrl = (url) => url.replace(regexp, '');

export default {
	fromArray,
	fromUrl
};
